import { render, staticRenderFns } from "./Pengiriman.vue?vue&type=template&id=de07dad2&"
import script from "./Pengiriman.vue?vue&type=script&lang=js&"
export * from "./Pengiriman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports